import slice from './customers.slice'

export const selectSlice = (state) => state[slice.name]

export const selectAccounts = (state) => selectSlice(state).accounts

export const selectUsers = (state) => selectSlice(state).users

export const selectSelectedCustomerModal = (state) =>
	selectSlice(state).selectedCustomerModal

export const selectFilters = (state) => selectSlice(state).customerFilters

export const selectSelectedAccounts = (state) =>
	selectSlice(state).selectedAccounts

export const selectSelectedRow = (state) => selectSlice(state).selectedRow

export const selectSelectedAccountId = (state) =>
	selectSlice(state).selectedAccount

export const selectCustomerPlans = (state) => selectSlice(state).customerPlans

export const selectPreviousFilters = (state) =>
	selectSlice(state).previousFilters

export const selectFfls = (state) => selectSlice(state).ffls
